import ApiService from 'services/ApiService';
import { httpClient } from 'utils/http';

export interface ApplicationRouteModel {
        id: number;
        applicationid: number;
        route: string;
        method_get: number;
        method_put: number;
        method_post: number;
        method_delete: number;
        authLevel: string;
}

class ApplicationRouteService extends ApiService<ApplicationRouteModel> {
        constructor() {
                super('applicationroute');
        }

        async getByApplicationId(applicationId: string | number): Promise<ApplicationRouteModel[]> {
                const params = new URLSearchParams({
                        limit: '0',
                        where: JSON.stringify({ applicationid: applicationId }),
                });
                const response = await httpClient.get<ApplicationRouteModel[]>(`/api/applicationroute?${params}`);
                return response.data;
        }
}

export default new ApplicationRouteService();
